var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrade = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00A32E",
  d: "m8.85 17.825 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425zM5.825 22l1.625-7.025L2 10.25l7.2-.625L12 3l2.8 6.625 7.2.625-5.45 4.725L18.175 22 12 18.275z"
}))));
export { SvgGrade as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vZ3JhZGUiPgo8bWFzayBpZD0ibWFzazBfNjE3MV8xODc2MiIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KPHJlY3QgaWQ9IkJvdW5kaW5nIGJveCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF82MTcxXzE4NzYyKSI+CjxwYXRoIGlkPSJncmFkZSIgZD0iTTguODUgMTcuODI1TDEyIDE1LjkyNUwxNS4xNSAxNy44NUwxNC4zMjUgMTQuMjVMMTcuMSAxMS44NUwxMy40NSAxMS41MjVMMTIgOC4xMjVMMTAuNTUgMTEuNUw2LjkgMTEuODI1TDkuNjc1IDE0LjI1TDguODUgMTcuODI1Wk01LjgyNSAyMkw3LjQ1IDE0Ljk3NUwyIDEwLjI1TDkuMiA5LjYyNUwxMiAzTDE0LjggOS42MjVMMjIgMTAuMjVMMTYuNTUgMTQuOTc1TDE4LjE3NSAyMkwxMiAxOC4yNzVMNS44MjUgMjJaIiBmaWxsPSIjMDBBMzJFIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";